import * as React from "react";
import LoginPopup from "../generic/loginPopup";
import DeviceContext from "../../../services/indentifyDevice";
import LoginFormBtmTxt from "../generic/loginFormBtmTxt";
import EdButton from "../../generic/edButton";
import YobInputField from "../generic/yobInputField";
import "../../../assets/scss/Login/login/loginScreen/loginScreen.scss";
import "../../../assets/scss/Login/login/loginScreen/yobScreen.scss";
import LoginErrMsg from "../generic/loginErrMsg";
import NuvamaLogo from "../../../assets/new_images/nuvama-logo.svg";

export interface IYobScreenProps {
  disableForm: boolean;
  errorMsg?: string;
  onSubmit: (yob: string) => void;
  onClose?: () => void;
  onRemoveError: () => void; // removes the errorMsg
}

const YobScreen: React.FC<IYobScreenProps> = (props) => {
  const [yob, setYob] = React.useState("");

  function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    props.onSubmit(yob);
  }

  React.useEffect(() => {
    if (props.errorMsg) {
      props.onRemoveError();
    }
  }, [yob]);

  return (
    <LoginPopup
      leftHeaderContent={
        !DeviceContext().isDesktop ? (
          <img className="logo1" src={NuvamaLogo} alt="nuvama-logo" />
        ) : undefined
      }
      centerHeaderContent={
        DeviceContext().isDesktop ? (
          <img className="logo1" src={NuvamaLogo} alt="nuvama-logo" />
        ) : undefined
      }
      onClose={props.onClose}
      className="login_scrn"
    >
      <div className="login_form yob_form">
        <form onSubmit={handleSubmit} autoComplete="off" className="mg-b60">
          <label className="inp_lbl mg-b15 ib">Year of Birth</label>

          <YobInputField placeholder="Y" onChange={setYob} />
          <p className="help_text mg-b40">
            * For HUF/corporate, enter your year of incorporation/ registration.
          </p>

          {props.errorMsg && (
            <LoginErrMsg className="mg-b40">{props.errorMsg}</LoginErrMsg>
          )}

          <EdButton
            value="Proceed"
            btnTyp="primary"
            className="submit_btn"
            disabled={props.disableForm || yob.length < 4}
          />
        </form>

        <LoginFormBtmTxt />
      </div>
    </LoginPopup>
  );
};

export default YobScreen;
